"use strict";

angular
    .module("imagetrend.components")
    .controller("hlpDateController", [
        "$scope",
        "Format",
        "$filter",
        "Validation",
        "$timeout",
        function($scope, Format, $filter, Validation, $timeout) {
            var initialized = false;
            $scope.todayLoading = false;

            $scope.setTime = function(time) {
                if (time == null) {
                    time = new Date();
                    time.setHours(0, 0, 0, 0);
                }
                $scope.time = time;

                if (isValidDate($scope.ngModel)) {
                    $scope.ngModel.setHours(time.getHours());
                    $scope.ngModel.setMinutes(time.getMinutes());
                }
            };

            $scope.$watch("ngModel", function (ngModel) {
                if (!isUndefined(ngModel) && !initialized) {
                    if (typeof ngModel != "object") {
                        ngModel = new Date(ngModel.toString());
                    } 
                    if ($scope.useTime) {
                        var d = new Date();
                        d.setHours(ngModel.getHours());
                        d.setMinutes(ngModel.getMinutes());
                        $scope.time = d;
                    } else {
                        ngModel.setHours(0);
                        ngModel.setMinutes(0);
                    }
                    initialized = true;
                }
                // if date field is cleared, set view to null
                if (ngModel === null && $scope.innerForm.date != null) {
                    $scope.innerForm.date.$setViewValue(null);
                    $scope.refresh = true;
                    $scope.onChange($scope.ngModel);
                    $scope.innerForm.date.$render();
                }
            });

            $scope.$watch("refresh", function(refresh) {
                if (!isUndefined($scope.ngModel) && refresh) {
                    $scope.todayLoading = true;
                    if ($scope.useTime) {
                        var d = new Date();
                        d.setHours($scope.ngModel.getHours());
                        d.setMinutes($scope.ngModel.getMinutes());
                        $scope.time = d;
                    } else {
                        $scope.ngModel.setHours(0);
                        $scope.ngModel.setMinutes(0);
                    }
                    $scope.refresh = false;
                    $scope.todayLoading = false;
                }
            });

            $scope.opened = false;

            $scope.dateOptions = {
                showWeeks: false
            };

            $scope.altInputFormats = [
                "MM/dd/yyyy",
                "MM/dd/yy",
                "MM/d/yyyy",
                "MM/d/yy",
                "M/d/yyyy",
                "M/d/yy",
                "M/dd/yyyy",
                "M/dd/yy"
            ];
            $scope.format = $scope.altInputFormats[1];

            if ($scope.month) {
                $scope.dateOptions.minMode = "month";
                $scope.altMonthInputFormats = [
                    "MM/yyyy",
                    "M/yyyy"
                ];
                $scope.format = $scope.altMonthInputFormats[1];
            }

            $scope.today = function() {
                $scope.todayLoading = true;
                $scope.ngModel = new Date();
                $scope.innerForm.date.$setViewValue(
                    $scope.ngModel.getMonth() +
                        1 +
                        "/" +
                        $scope.ngModel.getDate() +
                        "/" +
                        $scope.ngModel.getFullYear()
                );
                $scope.refresh = true;
                $scope.onChange($scope.ngModel);
                $scope.todayLoading = false;

                $scope.innerForm.date.$render();
                if ($scope.useCurrentTimeToday == true) {
                    //Set the time as the current time
                    $scope.setTime(new Date());
                }
            };

            $scope.validate = function () {
                if ($scope.innerForm !== undefined) {
                    Validation.validateQuestion(
                        $scope.innerForm.date,
                        $scope.validation,
                        $scope.ngModel
                    );
                    if (
                        $scope.question !== undefined &&
                        $scope.question.answer !== undefined
                    ) {
                        $scope.question.answer.invalid = !isEmpty(
                            $scope.innerForm.date.$error
                        );
                    }
                }
            };

            var validationTimeout = $timeout(function() {
                if (!$scope.requiredText) {
                    $scope.requiredText =
                        "Please enter a " +
                        Format.label($scope.label || $scope.name);
                    $scope.requiredText =
                        $scope.requiredText +
                        ($scope.month
                            ? " in MM/YYYY format"
                            : " in MM/DD/YYYY format");
                }
                $scope.validate();
            }, 0);

            $scope.$on("$destroy", function() {
                $timeout.cancel(validationTimeout);
            });
        }
    ])
    .directive("hlpDate", [
        "Format",
        "Validation",
        "$timeout",
        function(Format, Validation, $timeout) {
            return {
                restrict: "AE",
                scope: {
                    ngModel: "=",
                    question: "=",
                    refresh: "=?",
                    validation: "=?",

                    //attributes
                    name: "@?",
                    id: "@?",
                    classes: "@?",
                    full: "@?",
                    month: "=?",
                    autoComplete: '@?',

                    //required
                    isRequired: "=?",
                    showRequired: "=?",
                    requiredText: "@?",

                    //disabled
                    isDisabled: "=?",

                    //label
                    showLabel: "@?",
                    label: "@?",
                    title: "@?",
                    showToday: "@?",
                    useTime: "@?",
                    topLabel: "=?",
                    showColon: "=?",
                    vertical: "=?",
                    fixed: "=?",
                    useCurrentTimeToday: "=?",

                    //instructions
                    instructions: "@?",
                    pdf: "=?"
                },
                replace: true,
                transclude: true,
                require: "ngModel",
                templateUrl: "templates/date/date.html",
                link: function(scope, elem, attrs, ctrl) {
                    scope.timeouts = [];
                    scope.autoComplete = attrs.autoComplete;

                    //attributes
                    if (!attrs.name) {
                        attrs.name = "date";
                    }
                    if (!attrs.id) {
                        attrs.id = attrs.name;
                    }
                    if (!attrs.full) {
                        attrs.full = false;
                    } else {
                        if (attrs.full == "true") {
                            attrs.full = true;
                        } else {
                            attrs.full = false;
                        }
                    }
                    if (!attrs.month) {
                        attrs.month = false;
                    } else {
                        if (attrs.month == "true") {
                            attrs.month = true;
                        } else {
                            attrs.month = false;
                        }
                    }

                    //label
                    if (!attrs.label) {
                        attrs.label = Format.label(attrs.name);
                    }
                    if (!attrs.showLabel) {
                        attrs.showLabel = attrs.label.length > 0;
                    } else {
                        if (attrs.showLabel == "true") {
                            attrs.showLabel = true;
                        } else {
                            attrs.showLabel = false;
                        }
                    }
                    if (!attrs.vertical) {
                        attrs.vertical = false;
                    } else {
                        if (
                            attrs.vertical == true ||
                            attrs.vertical == "true"
                        ) {
                            attrs.vertical = true;
                        } else {
                            attrs.vertical = false;
                        }
                    }
                    if (!attrs.topLabel) {
                        attrs.topLabel = false;
                    } else {
                        if (
                            attrs.topLabel == true ||
                            attrs.topLabel == "true"
                        ) {
                            attrs.topLabel = true;
                        } else {
                            attrs.topLabel = false;
                        }
                    }
                    if (!attrs.showColon) {
                        attrs.showColon = true;
                    } else {
                        if (
                            attrs.showColon == true ||
                            attrs.showColon == "true"
                        ) {
                            attrs.showColon = true;
                        } else {
                            attrs.showColon = false;
                        }
                    }
                    if (!attrs.title) {
                        if (attrs.month == "true" || attrs.month == true) {
                            attrs.title = "Please enter in mm/yyyy format";
                        } else {
                            attrs.title =
                                "Please enter date in mm/dd/yyyy format";
                        }
                    }
                    if (!attrs.showToday) {
                        attrs.showToday = true;
                    } else {
                        if (attrs.showToday == "true") {
                            attrs.showToday = true;
                        } else {
                            attrs.showToday = false;
                        }
                    }
                    if (!attrs.useTime) {
                        attrs.useTime = false;
                    } else {
                        if (attrs.useTime == "true") {
                            attrs.useTime = true;
                        } else {
                            attrs.useTime = false;
                        }
                    }
                    scope.formatText =
                        "Please enter a valid date" +
                        (attrs.month
                            ? " in MM/YYYY format"
                            : " in MM/DD/YYYY format");

                    //required
                    //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }

                    scope.onChange = function(item) {
                        scope.ngModel = item;
                        scope.submitted = false;
                        ctrl.$setViewValue(item);
                        if (scope.validation) {
                            Validation.validateQuestion(
                                scope.innerForm.date,
                                scope.validation,
                                ctrl.$modelValue
                            );
                        }
                        if (
                            scope.question !== undefined &&
                            scope.question.answer !== undefined
                        ) {
                            scope.question.answer.invalid = !isEmpty(
                                scope.innerForm.date.$error
                            );
                        }
                    };
                    //ctrl.$viewChangeListeners.push(function () {
                    //    scope.$eval(attrs.ngChange);
                    //});

                    scope.submitted = false;
                    scope.$on("form:submit", function() {
                        scope.validate();
                        scope.submitted = true;
                    });

                    scope.$on("$destroy", function() {
                        scope.timeouts.forEach(function(timer) {
                            $timeout.cancel(timer);
                        });
                        if (elem) {
                            angular.element(elem).remove();
                            elem = null;
                        }
                    });
                },
                controller: "hlpDateController"
            };
        }
    ]);
